Morris.Area.prototype.fillForSeries = function (i) {
    return '90-#00a3ff-#00c1ff:90-#00c7ff-#00cbff';
}

let prod = false;

$(document).ready(function () {
    function isPageForManagers(){
        let currentPageUrl = window.location.href;

        return currentPageUrl.includes('/static-analyzer');
    }

    function isElementForFocusOnEssentialsLast(element_index){
        return element_index === 5;
    }

    function hideImageForFocusOnEssentialsElement(image_index){
        $('.b-advantages__image').find($(`[data-index=${image_index}]`)).css('display', 'none');
    }

    function showImageForFocusOnEssentialsElement(image_index){
        $('.b-advantages__image').find($(`[data-index=${image_index}]`)).css('display', 'block');
    }

    function changeImageForFocusOnEssentialsElement(previous_element_index, new_element_index){
        hideImageForFocusOnEssentialsElement(previous_element_index);
        showImageForFocusOnEssentialsElement(new_element_index);
    }

    // Advantages
    $('.b-advantages__item').on('click', function () {
        if (isPageForManagers()){
            let new_element_index = $(this).attr('data-index');
            let id_for_active_element_image = $('.b-advantages__item.b-advantages__item--active').attr('data-index');

            changeImageForFocusOnEssentialsElement(id_for_active_element_image, new_element_index)
        }

        setActive($(this).attr('data-index'));
        $(this).addClass('b-advantages__item--hover');
        clearInterval(timer);
    });

    $('.b-advantages__item').on('mousemove', function () {
        if ($(this).hasClass('b-advantages__item--active')) {
            $(this).addClass('b-advantages__item--hover');
            clearInterval(timer);
        }
    });

    $('.b-advantages__item').on('mouseleave', function () {
        if ($(this).hasClass('b-advantages__item--active')) {
            $(this).removeClass('b-advantages__item--hover');
            goAhead();
        }
    });

    const advantages = $('.b-advantages__item');
    let activeItem = 0;

    let timer;

    function goAhead() {
        timer = setInterval(function () {
            activeItem++;
            setActive(activeItem);
        }, 10000);
    }

    let params = window
    .location
    .search
    .replace('?','')
    .split('&')
    .reduce(
        function(p,e){
            var a = e.split('=');
            p[ decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
            return p;
        },
        {}
    );

    function setActive(index) {
        if(params['screenshot'] === '1') return;

        if (isPageForManagers()){
            let previous_element_index = index - 1;
            let new_element_index = isElementForFocusOnEssentialsLast(index) ? 0 : index;
            
            changeImageForFocusOnEssentialsElement(previous_element_index, new_element_index)
        }

        activeItem = index === advantages.length ? 0 : index;
        advantages.removeClass('b-advantages__item--active');
        $(advantages[activeItem]).addClass('b-advantages__item--active');
    }


    let block_show = null;

    function scrollTracking() {
        var wt = $(window).scrollTop();
        var wh = $(window).height();
        var et = $('.b-advantages').offset().top;
        var eh = $('.b-advantages').outerHeight();

        if (wt + wh >= et && wt + wh - eh * 2 <= et + (wh - eh)) {
            if (block_show == null || block_show == false) {
                setActive(activeItem);
                goAhead();
            }
            block_show = true;
        } else {
            if (block_show == null || block_show == true) {
                advantages.removeClass('b-advantages__item--active');
                clearInterval(timer);
            }
            block_show = false;
        }
    }

    const advant = $('.b-advantages');

    if (advant.length !== 0) {
        $(window).scroll(function () {
            scrollTracking();
        });

        $(document).ready(function () {
            scrollTracking();
        });
    }
});


(function ($) {
    if (prod) {
        $.fn.tooltips = function (el) {

            let $tooltip,
                $body = $('body'),
                $el;

            return this.each(function (i, el) {
                $el = $(el).attr('data-tooltip', i);

                const content = elementData[i].content ? elementData[i].content : '';
                let $tooltip = $('<div class="tooltip" data-tooltip="' + i + '">' + content + '<div class="arrow"></div></div>').appendTo('body');

                let linkPosition = $el.position();

                $tooltip.css({
                    top: linkPosition.top + 13,
                    left: linkPosition.left - 30
                });

                $el
                    .removeAttr('title')

                    .hover(function () {
                        $el = $(this);

                        $tooltip = $('div[data-tooltip=' + $el.data('tooltip') + ']');

                        var linkPosition = $el.position();

                        $tooltip.css({
                            top: linkPosition.top,
                        });

                        $('circle').removeClass('hovered');
                        $('.tooltip').removeClass('hovered').removeClass('active').removeClass('out');
                        $tooltip.addClass('active');
                        $el.addClass('hovered');

                    }, function () {
                        $el = $(this);
                        $tooltip = $('div[data-tooltip=' + $el.data('tooltip') + ']').addClass('out');

                        setTimeout(function () {
                            if (!$tooltip.hasClass('hovered')) {
                                $tooltip.removeClass('active').removeClass('out');
                                $el.removeClass('hovered');
                            }
                        }, 100);
                    });

                $tooltip.hover(function () {
                    $tooltip.addClass('hovered')
                }, function () {
                    setTimeout(function () {
                        $tooltip.removeClass('active').removeClass('out').removeClass('hovered');
                        $el.removeClass('hovered');
                    });
                });
            });
        }
    }
})(jQuery);